export default "__VITE_PUBLIC_ASSET__ca09a8d1__"